// Small allow-list HTML sanitizer for letter bodies (defence in depth: the backend sanitizes on save too).
const ALLOWED_TAGS = new Set([
  "p", "br", "b", "strong", "i", "em", "u", "ul", "ol", "li", "h1", "h2", "h3", "h4",
  "div", "span", "table", "thead", "tbody", "tr", "td", "th", "hr", "blockquote", "sub", "sup",
]);
const DROP_WITH_CONTENT = new Set([
  "script", "style", "iframe", "object", "embed", "noscript", "template", "svg", "math", "head", "title", "link", "meta",
]);
const ALLOWED_STYLE_PROPS = new Set([
  "text-align", "font-size", "font-weight", "font-style", "text-decoration", "color", "line-height",
  "margin", "margin-left", "margin-top", "margin-bottom", "padding", "padding-left", "border", "border-collapse",
  "border-bottom", "border-top", "width", "vertical-align", "letter-spacing", "text-transform",
]);
const SAFE_VALUE = /^[\w\s#%.,()\-+/]+$/;

function cleanStyle(style) {
  const out = [];
  (style || "").split(";").forEach((decl) => {
    const idx = decl.indexOf(":");
    if (idx < 0) return;
    const prop = decl.slice(0, idx).trim().toLowerCase();
    const val = decl.slice(idx + 1).trim();
    if (!ALLOWED_STYLE_PROPS.has(prop)) return;
    if (!SAFE_VALUE.test(val) || /url\(|expression|javascript/i.test(val)) return;
    out.push(`${prop}: ${val}`);
  });
  return out.join("; ");
}

function walk(node, outDoc) {
  const frag = outDoc.createDocumentFragment();
  node.childNodes.forEach((child) => {
    if (child.nodeType === 3) {
      frag.appendChild(outDoc.createTextNode(child.nodeValue));
    } else if (child.nodeType === 1) {
      const tag = child.tagName.toLowerCase();
      if (DROP_WITH_CONTENT.has(tag)) return;
      const inner = walk(child, outDoc);
      if (!ALLOWED_TAGS.has(tag)) {
        frag.appendChild(inner); // unwrap unknown tag, keep its text
        return;
      }
      const el = outDoc.createElement(tag);
      const style = cleanStyle(child.getAttribute("style"));
      if (style) el.setAttribute("style", style);
      if (tag === "td" || tag === "th") {
        ["colspan", "rowspan"].forEach((a) => {
          const v = child.getAttribute(a);
          if (v && /^\d{1,2}$/.test(v)) el.setAttribute(a, v);
        });
      }
      el.appendChild(inner);
      frag.appendChild(el);
    }
  });
  return frag;
}

export function sanitizeHtml(html) {
  if (!html) return "";
  if (typeof DOMParser === "undefined") return "";
  const doc = new DOMParser().parseFromString(`<body>${html}</body>`, "text/html");
  const outDoc = document.implementation.createHTMLDocument("");
  const holder = outDoc.createElement("div");
  holder.appendChild(walk(doc.body, outDoc));
  return holder.innerHTML;
}

export const escapeHtml = (s) =>
  String(s ?? "")
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;");
